<template>
  <div>
    <div class="row slim-grid-row">
      <div class="col-12">
        <p class="body-1-4">Promo Code</p>
      </div>
      <div class="col-7">
        <div class="w-100 border-secondary-t radius-6 position-relative" :class="error != '' ? 'shake-el border-danger' : ''" style="padding-block: 12.3px;">
          <input :disabled="is_load" type="text" class="w-100 no-focus-border border-none body-1-4 radius-6 text-ticket pl-3 pr-5" v-model="form" @keyup.enter="$refs.btn_promo.handleClick()">
          <div v-if="form != ''" class="position-absolute cursor-pointer" @click="clearPromoCode" style="top: 10px;right:10px;">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.221622 13.3683C0.521384 13.6596 1.01813 13.6596 1.30933 13.3683L6.7907 7.88694L12.2721 13.3683C12.5633 13.6596 13.0686 13.6681 13.3598 13.3683C13.651 13.0686 13.651 12.5804 13.3598 12.2892L7.87841 6.79924L13.3598 1.31787C13.651 1.02667 13.6596 0.529924 13.3598 0.238726C13.06 -0.0610364 12.5633 -0.0610364 12.2721 0.238726L6.7907 5.7201L1.30933 0.238726C1.01813 -0.0610364 0.512819 -0.069601 0.221622 0.238726C-0.0695761 0.538488 -0.0695761 1.02667 0.221622 1.31787L5.70299 6.79924L0.221622 12.2892C-0.0695761 12.5804 -0.078141 13.0771 0.221622 13.3683Z"
                fill="#777777" />
            </svg>
          </div>
        </div>
      </div>
      <div class="col-5">
        <state-button ref="btn_promo" variant="primary" block :click="applyPromo" size="lg"><span class="text-uppercase">{{ $t('ticket.apply') }}</span></state-button>
      </div>
      <div v-if="error != ''" class="col-12 mt-1">
        <p class="body-3-3 mb-0 text-danger">{{error}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapMutations } from 'vuex'
  import { get } from '@/services/index.js'
  import moment from 'moment'

  export default {
    props:{
      api_module:{
        type: String,
        default: ''
      },
      page_module:{
        type: String,
        default: ''
      },
      general_data:{
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        form: '',
        error: '',
        is_load: false,
        valid: ''
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getActivityTrxPromoCode','getActivityTrxProducts'])
    },
    mounted(){
      this.form = this.getActivityTrxPromoCode
    },
    methods:{
      ...mapMutations(['setActivityTrxPromoCode','updateTrxActivityProductPricing','restoreTrxActivityProduct']),
      applyPromo(is_clear=false){
        return new Promise((success,fail)=>{
          if(this.form == '' && !is_clear){
            this.error = 'Promo code is empty'
            success()
          }else{
            this.is_load = true
            this.error = ''
            this.loadProduct()
            .then(res=>{
              this.validateProductWithPromo(res).finally(()=>{
                this.is_load = false
                success()
              })
            })
            .catch(err=>{
              this.error = err == 'promo_code not found' ? 'Promo code not available' : err
              this.is_load = false
              fail()
            })
          }
        })
      },
      clearPromoCode(){
        this.error = ''
        if(this.getActivityTrxPromoCode != ''){
          // this.setActivityTrxPromoCode('')
          // this.restoreTrxActivityProduct()
          
          this.getActivityTrxProducts.forEach((product,product_i)=>{
            let product_is_in_promo = product.original_data.promotion_affected.best != null && product.original_data.promotion_affected.best.promotion_type == 'PROMO_CODE' && product.original_data.promotion_affected.best.promo_code == this.form
            if(product_is_in_promo){
              this.loadProductDetail(product,false)
              .then(res_detail=>{
                this.updateProductCart(res_detail,product)
              })
              .catch(err=>console.log("HIT API DETAIL : ", err))
            }


            if(product_i+1 == this.getActivityTrxProducts.length){
              this.setActivityTrxPromoCode('')
              this.form = ''
            }
          })
        }
      },
      validateProductWithPromo(product_list){
        return new Promise((done)=>{
          let copied_products = this.$deepCopy(product_list)
          let product_affected = copied_products.filter(product=>{
            if(product.promotion_affected.best != null && product.promotion_affected.best.promotion_type == 'PROMO_CODE' && product.promotion_affected.best.promo_code == this.form) return product
            else return false
          })
          if(product_affected.length > 0){
            let is_cart_have_promo = this.getActivityTrxProducts.some(v_product=>{
              let is_get_promo = product_affected.some(product=> product.id == v_product.original_data.id)
              if(is_get_promo)return true
              return false
            })
  
            if(is_cart_have_promo){
              this.getActivityTrxProducts.forEach((product,product_i)=>{
                let is_product_match = product_affected.some(x=>x.id == product.original_data.id)
                if(is_product_match){
                  this.loadProductDetail(product)
                  .then(res_detail=>{
                    this.updateProductCart(res_detail,product)
                  })
                  .catch(err=>console.log("HIT API DETAIL : ", err))
                }

                if(product_i+1 == this.getActivityTrxProducts.length){
                  this.setActivityTrxPromoCode(this.form)
                  done()
                }
              })
            }else{
              this.error = 'Sorry, this promo has no effect on the product you chose'  
              done()
            }
          }else{
            this.error = 'Promo code not available'
            done()
          }
        })
      },
      updateProductCart(data_from_api,data_from_vuex){
        const getPricing = (price) => {
          const getNewPrice = (key) => price[key] * Number(data_from_vuex.qty)
          const calculatePromotion = (base_price,promotion_pct) => {
            const promotionAmount = base_price*(promotion_pct/100)
            return base_price-promotionAmount
          }
          let pricing_data = {
            final: getNewPrice('price_sell_final_with_tax_service'),
            base: getNewPrice('price_sell'),
            promotion_amount: getNewPrice('promotion_amount'),
            promotion_pct: price.promotion_pct,
            taxes: getNewPrice('tax_amount'),
            services: getNewPrice('service_amount'),
            source: price
          }
          pricing_data.promotion_pct = this.$getPercentage(pricing_data.base,pricing_data.promotion_amount)

          
          const isPromotionZero = Math.round(price.promotion_pct) == 0;
          pricing_data.display = {
            base: pricing_data.base,
            final: isPromotionZero ? pricing_data.base : calculatePromotion(price.price_sell, Math.round(price.promotion_pct))*data_from_vuex.qty,
            promotion_pct: Math.round(price.promotion_pct)
          }
          
          return pricing_data;
        }
        
        let params_to_vuex = {
          product: data_from_api,
          qty: data_from_vuex.qty,
          date: data_from_vuex.service_date,
          time: {},
          place: data_from_vuex.place_choice,
          gender: data_from_vuex.therapist_gender,
          base_price: {}
        }

        if(data_from_vuex.service_time.id){
          let new_sch_i = data_from_api.schedule.findIndex(x=>x.id == data_from_vuex.service_time.id)
          if(new_sch_i != -1){
            let new_sch = data_from_api.schedule[new_sch_i]
            let pax_in_sch = new_sch.price_by_pax.some(x=> data_from_vuex.qty >= x.pax_start && data_from_vuex.qty <= x.pax_end)

            params_to_vuex.time = new_sch
            params_to_vuex.base_price = getPricing(new_sch.price)
          }
        }else{
          params_to_vuex.time = data_from_vuex.service_time
          params_to_vuex.base_price = getPricing(data_from_api.price)
        }
        this.updateTrxActivityProductPricing(params_to_vuex)
      },
      loadProduct(){
        return new Promise((success,fail)=>{
          let api_url = this.page_module == 'concierge-spa' ? 'spa/product' : `merchant-pos/${this.general_data.id}/product`
          get(this.api_module, api_url, {
            merchant_id: this.getMerchant.id,
            promo_code: this.form
          }).then(response => {
            let res = response.data
            if (res.success) {
              success(res.data)
            } else {
              fail(res.message)
            }
          })
        })
      },
      loadProductDetail(data,with_promo_code=true){
        return new Promise((success,fail)=>{
          let params = {
            merchant_id: this.getMerchant.id,
            qty: data.qty,
            date: moment(data.service_date).format("YYYY-MM-DD"),
          }
          if(with_promo_code){
            params.promo_code = this.form
          }
          let api_url = this.page_module == 'concierge-spa' ? `spa/product/${data.original_data.id}` : `merchant-pos/${this.general_data.id}/product/${data.original_data.id}`
          get(this.api_module, api_url, params).then(response => {
            let res = response.data
            if (res.success) {
              success(res.data)
            } else {
              fail(res.message)
            }
          })
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/activity/PromoCode.vue